module.exports = __webpack_public_path__ + "media/story_video.1950e299.mp4";